import { render, staticRenderFns } from "./GroupsList.vue?vue&type=template&id=33d2170f&scoped=true"
import script from "./GroupsList.vue?vue&type=script&lang=ts"
export * from "./GroupsList.vue?vue&type=script&lang=ts"
import style0 from "./GroupsList.vue?vue&type=style&index=0&id=33d2170f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d2170f",
  null
  
)

export default component.exports